import { CustomerSecurityComplianceDTO } from "../DTO/customerSecurityComplianceDTO";

export class CustomerSecurityCompliance{
    public customerId!: number;
    public dataRetentionMonths!: number;
    public twoFactorMandated!: boolean;

    public static mapFromDTO(param:CustomerSecurityComplianceDTO):CustomerSecurityCompliance{ 
        if (!param) throw new Error("parameter is null")
        let obj = new CustomerSecurityCompliance();
        try
        {
            obj.customerId = param.customerId;
            obj.dataRetentionMonths = param.dataRetentionMonths;
            obj.twoFactorMandated = param.twoFactorMandated;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return obj;
    }

    public static mapToDTO(param:CustomerSecurityCompliance):CustomerSecurityComplianceDTO{ 
        if (!param) throw new Error("parameter is null")
        let dto = new CustomerSecurityComplianceDTO();
        try
        {
            dto.customerId = param.customerId;
            dto.dataRetentionMonths = param.dataRetentionMonths;
            dto.twoFactorMandated = param.twoFactorMandated;
        }
        catch(e)
        {
            console.log(e);
            
        }
        return dto;
    }

}